import { useEffect, useState } from "react";
import { ChildFormController } from "../childForm/childFormController";
import { getStorageFieldLabel } from "../storageConfig/configData";
import { PasswordFormFieldsConfig } from "./passwordFormConfig";

const _props = {
    field: {},
    inputForm: {},
    controlConfig: {}
}
function Comp_ConfirmPassword(props = _props) {
    const { formState: { errors }, getValues: inputForm_getValues, setValue: setInputFormValue } = props.inputForm;
    const parent_field = props.controlConfig?.mappedParentField;
    const inputFormValues = inputForm_getValues() || {} ;
    const parent_field_value = inputFormValues[parent_field];
    const isNewUser = inputFormValues['actionType'] === 'create'
    const isFormAuthentication = (parent_field_value?.val || '').toLowerCase() === 'form'


    const [childFormRef, setChildFormRef] = useState()

    useEffect(() => {
        // debugger
        let value = undefined;
        if (isNewUser && isFormAuthentication && childFormRef) {
            const values = childFormRef.getValues();
            if (values.password !== values.confirmPassword) {
                value = undefined
            }
            else if(Object.keys(childFormRef.formState.errors).length === 0){
                value = values.password
            }
        }
        else{
            value  = " "
        }
        props?.field?.onChange(value)
        setInputFormValue(props.field.name, value)
    })

    const childFormConfig = PasswordFormFieldsConfig;

    return isNewUser && isFormAuthentication ? <div className="form-set-password">
        <ChildFormController
        controlConfig={props.controlConfig
        }
        currentFormField={props.field}
        inputForm={props.inputForm}
        childFormConfig={childFormConfig}
        childFormRef={setChildFormRef}
       
    />
    </div>
    : isFormAuthentication ? <span className="msg-password-reset">*You can set password from main screen.</span> : null
}

export const ConfirmPassword = Comp_ConfirmPassword;